import {
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import { LoadingButton } from "@mui/lab";
import { AuthContext } from "../../../context/AuthContext";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // ES 2015
import timezone from "dayjs/plugin/timezone"; // ES 2015
import isoWeek from "dayjs/plugin/isoWeek"; // ES 2015
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
const DEFAULT_TIMEZONE = "America/Phoenix";
dayjs.tz.setDefault(DEFAULT_TIMEZONE);

const ReasonDialog = ({
  disabled,
  title,
  value,
  open,
  handleClose,
  onSubmit,
}) => {
  const theme = useTheme();
  const { ezorder, authToken } = useContext(AuthContext);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [reason, setReason] = useState(value);

  return (
    <Dialog
      keepMounted
      scroll={"paper"}
      maxWidth="sm"
      fullWidth={true}
      open={open}
      onClose={() => {
        setReason(value); // restore reason value if cancelled
        handleClose();
      }}
    >
      <DialogTitle>{title ? title : "Reason"}</DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <TextField
          disabled={disabled}
          variant="outlined"
          size="small"
          fullWidth
          multiline={true}
          rows={5}
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
          }}
        />
        <Box sx={{ marginTop: "16px" }}>
          {errorMessage && (
            <Box>
              <Typography color={"red"}>{errorMessage}</Typography>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        {disabled ? (
          <LoadingButton
            onClick={() => {
              setErrorMessage("");
              setReason(value); // restore reason value if cancelled
              handleClose();
            }}
            loading={loading || loadingUsers}
          >
            Close
          </LoadingButton>
        ) : (
          <>
            <LoadingButton
              onClick={() => {
                setErrorMessage("");
                setReason(value); // restore reason value if cancelled
                handleClose();
              }}
              loading={loading || loadingUsers}
            >
              Cancel
            </LoadingButton>
            <LoadingButton
              variant="contained"
              loading={loading || loadingUsers}
              onClick={() => {
                onSubmit(reason);
              }}
            >
              Submit
            </LoadingButton>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};
export default ReasonDialog;
